module.exports = __webpack_public_path__ + "static/media/accesorios.97ae496b.png";